import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
const SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
  const {
    children,
    className,
    component: Component = 'svg',
    viewBox = '0 0 24 24',
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: `sb-icon${className ? ` ${className}` : ''}`,
    focusable: "false",
    viewBox: viewBox,
    "aria-hidden": true,
    ref: ref
  }, rest), children);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
  viewBox: PropTypes.string
} : void 0;
export default SvgIcon;